import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)


const messages = {
    en: {

        AddonAdda: "Add an Adda",
        notFindAdda: "Couldnot locate your Adda? Please add your Adda",
        AddPhoto: "Add Photo",
        earnMpoints: "Add an Adda or Checkin on an Adda to earn MPoints",
        postOffice: "Post office",
        meter: "meter",
        VerifiedbyMall91: "Verified by Mall91",
        Suggestandedit: "Suggest an edit",
        GiveRating: "Give Rating",
        Details: "Details",
        MondaytoSaturday: "Monday to Saturday",
        checkIn: "Checkin",
        CheckInAtAdda: "Checkin at an Adda",
        ShareExperience: "Share your experience with Adda and earn MPoints",
        AddaName: "Name of Adda",
        AddAddanotfound: "Adda not found",
        Iamhere: "I'm here",
        Writesomethinghere: "Please write few words..",
        plzCheckin: "Checkin",
        PickyourCurrentLocation: "Pick your current location",
        TurnonLocation: "Turn Location Services on",
        NoRecordsavailable: "No records available",
        YoursPosts: "Yours Posts",
        Makeasuggestion: "Make a Suggestion",
        Helpwithyoursuggestion: "Help us with your valuable suggestions",
        Addnewphoto: "Add new photo",
        warning: "Support your suggestions with relevant pictures and accurate information.",
        submit: "Submit",
        AllcheckIns: "All Checkins",
        Nearbycheckins: "Nearby Checkins",
        Home: "Home",
        AllAddas: "All Addas",
        Notification: "Notification",
        Profile: "Profile",
        TotalPost: "Total Posts",
        TotalLikes: "Total Likes",
        TotalComments: "Total Comments",
        Peoplehavecommented: "People have made comments",
        TypeAcomment: "Type your content here..",
        GototheAdda: "Go to an Adda",
        intro: "Add a new Adda or checkin on an Adda and earn MPoints",
        Peoplehaveliked: "people have liked",
        whichplaceyoustand: "At which Adda are you now? Checkin!",
        Atwhichplace: "At which Adda are you now? Checkin!",
        likes: "Likes",
        share: "Share",
        like: "Like",
        comments: "Comments",
        isAt: "is at",
        FullAddress: "Full Address",
        housenumber: "House Number, Street or Village",
        BusinessName: "Business Name",
        Suchas: "Agarwal Confectionery",
        AddNewCategory: "Add New Category",
        CREATE: "CREATE",
        CANCEL: "CANCEL",
        city: "City",
        addCity: "Add City",
        Mobile: "Contact Number",
        enterMobileNumber: "Enter Mobile Number",
        pincode: "PIN",
        enterpincode: "PIN",
        state: "State",
        AddState: "Add State",
        wentWrong: "Something went wrong!! Please try again",
        category: "Category",
        Createcategory: "Create category",
        UploadingImage: "Uploading Image",
        AddAdda: "Add Adda",
        nofeed: "Adda's are empty now",
        PleaseEnterdetails: "Please Enter details",
        Pleaseentercomment: "Please enter comment",


    },
    hi: {
        AddonAdda: "अड्डा जोड़ें",
        notFindAdda: "आपको अपना अड्डा नहीं मिला? कृपया अपना अड्डा जोड़ें",
        AddPhoto: "फ़ोटो जोड़ें",
        earnMpoints: "अपना अड्डा जोड़ें या किसी अड्डे पे चेकइन करें और कमाएं MPoints",
        postOffice: "पोस्ट ऑफिस",
        meter: "मीटर",
        VerifiedbyMall91: "Mall91 द्वारा प्रमाणित",
        Suggestandedit: "संपादन का सुझाव दें",
        GiveRating: "रेटिंग दें",
        Details: "विवरण",
        MondaytoSaturday: "सोमवार से शनिवार",
        checkIn: "चेकइन",
        CheckInAtAdda: "अड्डे पर चेकइन",
        ShareExperience: "अड्डे के साथ अपना अनुभव शेयर करे और M-पॉइंट कमाएं",
        AddaName: "अड्डे का नाम",
        AddAddanotfound: "अड्डा नहीं मिला",
        Iamhere: "मैं यहाँ हूँ",
        Writesomethinghere: "यहाँ कुछ लिखे….",
        plzCheckin: "चेकइन करें",
        PickyourCurrentLocation: "अपना वर्तमान स्थान चुनें",
        TurnonLocation: "लोकेशन सर्विसेस चालू करें",
        NoRecordsavailable: "कोई रिकॉर्ड उपलब्ध नहीं है",
        YoursPosts: "आपकी पोस्ट",
        Makeasuggestion: "सुझाव दें",
        Helpwithyoursuggestion: "आपके बहुमूलय सुझाव सांझा करें",
        Addnewphoto: "नया फोटो जोड़े",
        warning: "अपने सुझाव के साथ प्रासंगिक चित्र और सटीक जानकारी सांझी करें",
        submit: "जमा करें",
        AllcheckIns: "सभी चेंकिन्स",
        Nearbycheckins: "आस पास के चेंकिन्स",
        Home: "होम",
        AllAddas: "सभी अड्डे",
        Notification: "अधिसूचना",
        Profile: "प्रोफ़ाइल",
        TotalPost: "कुल पोस्ट",
        TotalLikes: "कुल लाइक्स ",
        TotalComments: "कुल कॉमेंट्स ",
        Peoplehavecommented: "लोगो ने कॉमेंट्स किये हैं",
        TypeAcomment: "कमेंट टाइप करे..",
        GototheAdda: "अड्डे पर जाएं",
        intro: "अड्डा जोड़े यान किसी भी अड्डे पर चेकइन करें  और पाएं ढेरों MPoints",
        Peoplehaveliked: "लोगो ने लाइक् किया है",
        whichplaceyoustand: "अभी आप किस अड्डा पे हैं? चेकइन करें!",
        Atwhichplace: "अभी आप किस अड्डा पे हैं? चेकइन करें!",
        likes: "लाइक्स",
        share: "शेयर",
        like: "लाइक",
        comments: "कॉमेंट्स",
        isAt: "इज़ एट",
        FullAddress: "पूरा पता",
        housenumber: "मकान नंबर, गली या गांव जोड़ें",
        BusinessName: "अड्डे का नाम",
        Suchas: "जैसे: अगरवाल हलवाई",
        AddNewCategory: "नई केटेगरी जोड़ें",
        CREATE: "बनाएं",
        CANCEL: "रद्द करें",
        city: "शहर",
        addCity: "शहर जोड़ें",
        enterMobileNumber: "मोबाइल नंबर दर्ज करें",
        Mobile: "मोबाइल",
        pincode: "पिन कोड",
        enterpincode: "पिन कोड जोड़ें",
        state: "राज्य",
        AddState: "राज्य जोड़ें",
        wentWrong: "कुछ गलत हो गया!! कृपया पुन: प्रयास करें",
        category: "केटेगरी ",
        Createcategory: "केटेगरी बनायें ",
        UploadingImage: "फोटो अपलोड हो रही है",
        AddAdda: "अड्डा जोड़ें",
        nofeed: "अभी अड्डे खाली हैं",
        PleaseEnterdetails: "कृपया विवरण दर्ज करें",
        Pleaseentercomment: "कृपया कॉमेंट् दर्ज करें",
    },
    bn: {
        AddonAdda: "একটি অ্যাডা যুক্ত করুন",
        notFindAdda: "আপনার অ্যাডাকে সনাক্ত করা যায়নি? আপনার অ্যাডা যোগ করুন",
        AddPhoto: "ছবি জগকরুন",
        earnMpoints: "এমপিয়েন্ট অর্জন করতে একটি অ্যাডায় একটি অ্যাডা বা চেকইন যুক্ত করুন",
        postOffice: "ডাক ঘর",
        meter: "মিটার",
        VerifiedbyMall91: "মল 91 দ্বারা যাচাই করা হয়েছে",
        Suggestandedit: "একটি সম্পাদনার পরামর্শ দিন",
        GiveRating: "রেটিং দিন",
        Details: "বিস্তারিত",
        MondaytoSaturday: "সোমবার হতে শনিবার",
        checkIn: "চেকইন",
        CheckInAtAdda: "একটি অ্যাডায় চেক ইন",
        ShareExperience: "আড্ডার সাথে আপনার অভিজ্ঞতা ভাগ করুন এবং এমপিয়েন্ট অর্জন করুন",
        AddaName: "অ্যাডার নাম",
        AddAddanotfound: "অ্যাডা পাওয়া গেল না",
        Iamhere: "আমি এখানে",
        Writesomethinghere: "দয়া করে কয়েকটি শব্দ লিখুন ..",
        plzCheckin: "চেকইন",
        PickyourCurrentLocation: "আপনার বর্তমান অবস্থান চয়ন করুন",
        TurnonLocation: "অবস্থান পরিষেবাদি চালু করুন",
        NoRecordsavailable: "কোন রেকর্ড উপলব্ধ",
        YoursPosts: "আপনার পোস্ট",
        Makeasuggestion: "একটি উপদেশ বানান",
        Helpwithyoursuggestion: "আপনার মূল্যবান পরামর্শ সাহায্য করুন",
        Addnewphoto: "নতুন ছবি যুক্ত করুন",
        warning: "প্রাসঙ্গিক ছবি এবং সঠিক তথ্যের সাথে আপনার পরামর্শগুলিকে সমর্থন করুন।",
        submit: "জমা দিন",
        AllcheckIns: "সমস্ত চেক ইন",
        Nearbycheckins: "কাছাকাছি চেকইনস",
        Home: "বাড়ি",
        AllAddas: "সমস্ত অ্যাডাস",
        Notification: "প্রজ্ঞাপন",
        Profile: "প্রোফাইল",
        TotalPost: "মোট পোস্ট",
        TotalLikes: "মোট পছন্দ",
        TotalComments: "মোট মন্তব্য",
        Peoplehavecommented: "মানুষ মন্তব্য করেছে",
        TypeAcomment: "আপনার সামগ্রী এখানে লিখুন ..",
        GototheAdda: "একটি অ্যাডা যান",
        intro: "একটি অ্যাডায় একটি নতুন অ্যাডা বা চেকইন যুক্ত করুন এবং এমপিয়েন্ট অর্জন করুন",
        Peoplehaveliked: "মানুষ পছন্দ করেছে",
        whichplaceyoustand: "আপনি এখন কোন অ্যাডা? চেকইন!",
        Atwhichplace: "আপনি এখন কোন অ্যাডা? চেকইন!",
        likes: "পছন্দ",
        share: "ভাগ",
        like: "মত",
        comments: "মন্তব্য",
        isAt: "এ আছে",
        FullAddress: "পুরো ঠিকানা",
        housenumber: "বাড়ির নম্বর, রাস্তা বা গ্রাম",
        BusinessName: "প্রাতিষ্ঠানিক নাম",
        Suchas: "আগরওয়াল মিষ্টান্ন",
        AddNewCategory: "নতুন বিভাগ যুক্ত করুন",
        CREATE: "সৃষ্টি",
        CANCEL: "বাতিল",
        city: "শহর",
        addCity: "শহর যোগ করুন",
        Mobile: "যোগাযোগের নম্বর",
        enterMobileNumber: "মোবাইল নম্বর প্রবেশ করান",
        pincode: "পিন",
        enterpincode: "পিন",
        state: "রাষ্ট্র",
        AddState: "রাজ্য যুক্ত করুন",
        wentWrong: "কিছু ভুল হয়েছে!! আবার চেষ্টা করুন",
        category: "বিভাগ",
        Createcategory: "বিভাগ তৈরি করুন",
        UploadingImage: "ফটো আপলোড হচ্ছে",
        AddAdda: "অ্যাডা যোগ করুন",
        nofeed: "কোন খবর নেই",
        PleaseEnterdetails: "বিশদ লিখুন দয়া করে",
        Pleaseentercomment: "মন্তব্য লিখুন",
    },
    gu: {
        AddonAdda: "એક એડ ઉમેરો",
        notFindAdda: "તમારા અદા શોધી શક્યા નથી? કૃપા કરીને તમારી એડ્ડા ઉમેરો",
        AddPhoto: "ફોટો ઉમેરો",
        earnMpoints: "સાંસદોને કમાવવા માટે એક એડ્ડા પર એક એડ્ડા અથવા ચેકઇન ઉમેરો",
        postOffice: "પોસ્ટ ઓફીસ",
        meter: "મીટર",
        VerifiedbyMall91: "મોલ 91 દ્વારા ચકાસાયેલ",
        Suggestandedit: "સંપાદન સૂચવો",
        GiveRating: "રેટિંગ આપો",
        Details: "વિગતો",
        MondaytoSaturday: "સોમવારથી શનિવાર",
        checkIn: "ચેકિન",
        CheckInAtAdda: "એક એડ્ડા પર તપાસ કરો",
        ShareExperience: "અડા સાથે તમારો અનુભવ શેર કરો અને એમપીઇન્ટ્સ મેળવો",
        AddaName: "એડાનું નામ",
        AddAddanotfound: "અદા મળી નથી",
        Iamhere: "હુ અહિયા છુ",
        Writesomethinghere: "કૃપા કરીને થોડા શબ્દો લખો ..",
        plzCheckin: "ચેકિન",
        PickyourCurrentLocation: "તમારું વર્તમાન સ્થાન ચૂંટો",
        TurnonLocation: "સ્થાન સેવાઓ ચાલુ કરો",
        NoRecordsavailable: "કોઈ રેકોર્ડ ઉપલબ્ધ નથી",
        YoursPosts: "તમારી પોસ્ટ્સ",
        Makeasuggestion: "સૂચન આપો",
        Helpwithyoursuggestion: "તમારા મૂલ્યવાન સૂચનો માટે અમારી સહાય કરો",
        Addnewphoto: "નવો ફોટો ઉમેરો",
        warning: "સંબંધિત ચિત્રો અને સચોટ માહિતી સાથે તમારા સૂચનોને ટેકો આપો.",
        submit: "સબમિટ કરો",
        AllcheckIns: "બધા ચેકિન્સ",
        Nearbycheckins: "નજીકની ચેકિન્સ",
        Home: "ખેર",
        AllAddas: "બધા એડ્સ",
        Notification: "સૂચના",
        Profile: "પ્રોફાઇલ",
        TotalPost: "કુલ પોસ્ટ્સ",
        TotalLikes: "કુલ પસંદ",
        TotalComments: "કુલ ટિપ્પણીઓ",
        Peoplehavecommented: "લોકોએ ટિપ્પણી કરી છે",
        TypeAcomment: "તમારી સામગ્રી અહીં લખો ..",
        GototheAdda: "એક અદા પર જાઓ",
        intro: "એક એડ્ડા પર એક નવો એડ્ડા અથવા ચેકઇન ઉમેરો અને એમપીઇન્ટ્સ કમાઓ",
        Peoplehaveliked: "લોકોને ગમ્યું",
        whichplaceyoustand: "હવે તમે કયા અદા છો? ચેકિન!",
        Atwhichplace: "હવે તમે કયા અદા છો? ચેકિન!",
        likes: "પસંદ છે",
        share: "શેર કરો",
        like: "ગમે છે",
        comments: "ટિપ્પણીઓ",
        isAt: "પર છે",
        FullAddress: "પૂરું સરનામું",
        housenumber: "મકાન નંબર, શેરી અથવા ગામ",
        BusinessName: "વ્યવસાયનું નામ",
        Suchas: "અગ્રવાલ કન્ફેક્શનરી",
        AddNewCategory: "નવી કેટેગરી ઉમેરો",
        CREATE: "બનાવો",
        CANCEL: "રદ કરો",
        city: "શહેર",
        addCity: "શહેર ઉમેરો",
        Mobile: "સંપર્ક નંબર",
        enterMobileNumber: "મોબાઇલ નંબર દાખલ કરો",
        pincode: "પિન",
        enterpincode: "પિન",
        state: "રાજ્ય",
        AddState: "રાજ્ય ઉમેરો",
        wentWrong: "કંઈક ખોટું થયું!! મેહરબાની કરી ને ફરી થી પ્રયાસ કરો",
        category: "કેટેગરી",
        Createcategory: "કેટેગરી બનાવો",
        UploadingImage: "ફોટો અપલોડ",
        AddAdda: "એડ્ડા ઉમેરો",
        nofeed: "કોઈ સમાચાર નથી",
        PleaseEnterdetails: "કૃપા કરીને વિગતો દાખલ કરો",
        Pleaseentercomment: "કૃપા કરીને ટિપ્પણી દાખલ કરો",
    },

    kn: {
        AddonAdda: "ಆಡಾ ಸೇರಿಸಿ",
        notFindAdda: "ನಿಮ್ಮ ಆಡಾವನ್ನು ಕಂಡುಹಿಡಿಯಲು ಸಾಧ್ಯವಿಲ್ಲವೇ? ದಯವಿಟ್ಟು ನಿಮ್ಮ ಆಡಾವನ್ನು ಸೇರಿಸಿ",
        AddPhoto: "ಫೋಟೋ ಸೇರಿಸಿ",
        earnMpoints: "ಎಂಪಾಯಿಂಟ್‌ಗಳನ್ನು ಗಳಿಸಲು ಆಡಾದಲ್ಲಿ ಆಡಾ ಅಥವಾ ಚೆಕ್‌ಇನ್ ಸೇರಿಸಿ",
        postOffice: "ಅಂಚೆ ಕಛೇರಿ",
        meter: "ಮೀಟರ್",
        VerifiedbyMall91: "ಮಾಲ್ 91 ನಿಂದ ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
        Suggestandedit: "ಸಂಪಾದನೆಯನ್ನು ಸೂಚಿಸಿ",
        GiveRating: "ರೇಟಿಂಗ್ ನೀಡಿ",
        Details: "ವಿವರಗಳು",
        MondaytoSaturday: "ಸೋಮವಾರದಿಂದ ಶನಿವಾರದವರೆಗೆ",
        checkIn: "ಚೆಕ್ಇನ್",
        CheckInAtAdda: "ಆಡಾದಲ್ಲಿ ಚೆಕ್ಇನ್ ಮಾಡಿ",
        ShareExperience: "ನಿಮ್ಮ ಅನುಭವವನ್ನು ಆಡಾದೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಿ ಮತ್ತು ಸಂಸದರನ್ನು ಸಂಪಾದಿಸಿ",
        AddaName: "ಅಡಾದ ಹೆಸರು",
        AddAddanotfound: "ಆಡಾ ಕಂಡುಬಂದಿಲ್ಲ",
        Iamhere: "ನಾನು ಇಲ್ಲಿದ್ದೇನೆ",
        Writesomethinghere: "ದಯವಿಟ್ಟು ಕೆಲವು ಪದಗಳನ್ನು ಬರೆಯಿರಿ ..",
        plzCheckin: "ಚೆಕ್ಇನ್",
        PickyourCurrentLocation: "ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು ಆರಿಸಿ",
        TurnonLocation: "ಸ್ಥಳ ಸೇವೆಗಳನ್ನು ಆನ್ ಮಾಡಿ",
        NoRecordsavailable: "ಯಾವುದೇ ದಾಖಲೆಗಳು ಲಭ್ಯವಿಲ್ಲ",
        YoursPosts: "ನಿಮ್ಮ ಪೋಸ್ಟ್ಗಳು",
        Makeasuggestion: "ಒಂದು ಸಲಹೆಯನ್ನು ಮಾಡಿ",
        Helpwithyoursuggestion: "ನಿಮ್ಮ ಅಮೂಲ್ಯ ಸಲಹೆಗಳೊಂದಿಗೆ ನಮಗೆ ಸಹಾಯ ಮಾಡಿ",
        Addnewphoto: "ಹೊಸ ಫೋಟೋ ಸೇರಿಸಿ",
        warning: "ಸಂಬಂಧಿತ ಚಿತ್ರಗಳು ಮತ್ತು ನಿಖರವಾದ ಮಾಹಿತಿಯೊಂದಿಗೆ ನಿಮ್ಮ ಸಲಹೆಗಳನ್ನು ಬೆಂಬಲಿಸಿ.",
        submit: "ಸಲ್ಲಿಸು",
        AllcheckIns: "ಎಲ್ಲಾ ಚೆಕಿನ್‌ಗಳು",
        Nearbycheckins: "ಹತ್ತಿರದ ಚೆಕಿನ್‌ಗಳು",
        Home: "ಮನೆ",
        AllAddas: "ಎಲ್ಲಾ ಆಡಾಸ್",
        Notification: "ಅಧಿಸೂಚನೆ",
        Profile: "ಪ್ರೊಫೈಲ್",
        TotalPost: "ಒಟ್ಟು ಪೋಸ್ಟ್‌ಗಳು",
        TotalLikes: "ಒಟ್ಟು ಇಷ್ಟಗಳು",
        TotalComments: "ಒಟ್ಟು ಪ್ರತಿಕ್ರಿಯೆಗಳು",
        Peoplehavecommented: "ಜನರು ಕಾಮೆಂಟ್ ಮಾಡಿದ್ದಾರೆ",
        TypeAcomment: "ನಿಮ್ಮ ವಿಷಯವನ್ನು ಇಲ್ಲಿ ಟೈಪ್ ಮಾಡಿ ..",
        GototheAdda: "ಆಡಾಗೆ ಹೋಗಿ",
        intro: "ಆಡಾದಲ್ಲಿ ಹೊಸ ಆಡಾ ಅಥವಾ ಚೆಕ್ಇನ್ ಸೇರಿಸಿ ಮತ್ತು ಎಂಪಾಯಿಂಟ್‌ಗಳನ್ನು ಗಳಿಸಿ",
        Peoplehaveliked: "ಜನರು ಇಷ್ಟಪಟ್ಟಿದ್ದಾರೆ",
        whichplaceyoustand: "ನೀವು ಈಗ ಯಾವ ಅಡಾದಲ್ಲಿದ್ದೀರಿ? ಚೆಕ್ಇನ್!",
        Atwhichplace: "ನೀವು ಈಗ ಯಾವ ಅಡಾದಲ್ಲಿದ್ದೀರಿ? ಚೆಕ್ಇನ್!",
        likes: "ಇಷ್ಟಗಳು",
        share: "ಹಂಚಿಕೊಳ್ಳಿ",
        like: "ಲೈಕ್",
        comments: "ಪ್ರತಿಕ್ರಿಯೆಗಳು",
        isAt: "ನಲ್ಲಿ ಇದೆ",
        FullAddress: "ಪೂರ್ತಿ ವಿಳಾಸ",
        housenumber: "ಮನೆ ಸಂಖ್ಯೆ, ರಸ್ತೆ ಅಥವಾ ಗ್ರಾಮ",
        BusinessName: "ವ್ಯವಹಾರದ ಹೆಸರು",
        Suchas: "ಅಗರ್ವಾಲ್ ಮಿಠಾಯಿ",
        AddNewCategory: "ಹೊಸ ವರ್ಗವನ್ನು ಸೇರಿಸಿ",
        CREATE: "ರಚಿಸಿ",
        CANCEL: "ರದ್ದುಗೊಳಿಸಿ",
        city: "ನಗರ",
        addCity: "ನಗರವನ್ನು ಸೇರಿಸಿ",
        Mobile: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
        enterMobileNumber: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        pincode: "ಪಿನ್",
        enterpincode: "ಪಿನ್",
        state: "ರಾಜ್ಯ",
        AddState: "ರಾಜ್ಯವನ್ನು ಸೇರಿಸಿ",
        wentWrong: "ಏನೋ ತಪ್ಪಾಗಿದೆ!! ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ",
        category: "ವರ್ಗ",
        Createcategory: "ವರ್ಗವನ್ನು ರಚಿಸಿ",
        UploadingImage: "ಫೋಟೋ ಅಪ್‌ಲೋಡ್",
        AddAdda: "ಅಡಾ ಸೇರಿಸಿ",
        nofeed: "ಯಾವುದೇ ಸುದ್ದಿ ಇಲ್ಲ",
        PleaseEnterdetails: "ದಯವಿಟ್ಟು ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
        Pleaseentercomment: "ದಯವಿಟ್ಟು ಕಾಮೆಂಟ್ ನಮೂದಿಸಿ",



    },
    ml: {
        AddonAdda: "ഒരു അഡാ ചേർക്കുക",
        notFindAdda: "നിങ്ങളുടെ അഡാ കണ്ടെത്താൻ കഴിഞ്ഞില്ലേ? നിങ്ങളുടെ അഡാ ചേർക്കുക",
        AddPhoto: "ഫോട്ടോ ചേർക്കുക",
        earnMpoints: "MPoints നേടുന്നതിന് ഒരു Adda- ൽ ഒരു Adda അല്ലെങ്കിൽ Checkin ചേർക്കുക",
        postOffice: "പോസ്റ്റ് ഓഫീസ്",
        meter: "മീറ്റർ",
        VerifiedbyMall91: "Mall91 പരിശോധിച്ചത്",
        Suggestandedit: "ഒരു എഡിറ്റ് നിർദ്ദേശിക്കുക",
        GiveRating: "റേറ്റിംഗ് നൽകുക",
        Details: "വിശദാംശങ്ങൾ",
        MondaytoSaturday: "തിങ്കൾ മുതൽ ശനി വരെ",
        checkIn: "വന്നുചേരുകയും പേര്രജിസ്റ്റര് ചെയ്യുകയും ചെയ്യുക",
        CheckInAtAdda: "ഒരു അഡയിൽ ചെക്ക് ഇൻ ചെയ്യുക",
        ShareExperience: "അഡയുമായി നിങ്ങളുടെ അനുഭവം പങ്കിട്ട് എംപോയിന്റുകൾ നേടുക",
        AddaName: "അഡയുടെ പേര്",
        AddAddanotfound: "അഡാ കണ്ടെത്തിയില്ല",
        Iamhere: "ഞാൻ ഇവിടെയുണ്ട്",
        Writesomethinghere: "കുറച്ച് വാക്കുകൾ എഴുതുക ..",
        plzCheckin: "വന്നുചേരുകയും പേര്രജിസ്റ്റര് ചെയ്യുകയും ചെയ്യുക",
        PickyourCurrentLocation: "നിങ്ങളുടെ നിലവിലെ സ്ഥാനം തിരഞ്ഞെടുക്കുക",
        TurnonLocation: "ലൊക്കേഷൻ സേവനങ്ങൾ ഓണാക്കുക",
        NoRecordsavailable: "റെക്കോർഡുകളൊന്നും ലഭ്യമല്ല",
        YoursPosts: "നിങ്ങളുടെ പോസ്റ്റുകൾ",
        Makeasuggestion: "ഒരു നിർദ്ദേശം നൽകുക",
        Helpwithyoursuggestion: "നിങ്ങളുടെ വിലയേറിയ നിർദ്ദേശങ്ങൾ ഉപയോഗിച്ച് ഞങ്ങളെ സഹായിക്കുക",
        Addnewphoto: "പുതിയ ഫോട്ടോ ചേർക്കുക",
        warning: "പ്രസക്തമായ ചിത്രങ്ങളും കൃത്യമായ വിവരങ്ങളും ഉപയോഗിച്ച് നിങ്ങളുടെ നിർദ്ദേശങ്ങളെ പിന്തുണയ്ക്കുക.",
        submit: "സമർപ്പിക്കുക",
        AllcheckIns: "എല്ലാ ചെക്കിനുകളും",
        Nearbycheckins: "അടുത്തുള്ള ചെക്കിനുകൾ",
        Home: "വീട്",
        AllAddas: "എല്ലാ അഡാസുകളും",
        Notification: "അറിയിപ്പ്",
        Profile: "പ്രൊഫൈൽ",
        TotalPost: "ആകെ പോസ്റ്റുകൾ",
        TotalLikes: "ആകെ ലൈക്കുകൾ",
        TotalComments: "ആകെ അഭിപ്രായങ്ങൾ",
        Peoplehavecommented: "ആളുകൾ അഭിപ്രായമിട്ടു",
        TypeAcomment: "നിങ്ങളുടെ ഉള്ളടക്കം ഇവിടെ ടൈപ്പുചെയ്യുക ..",
        GototheAdda: "ഒരു അഡയിലേക്ക് പോകുക",
        intro: "ഒരു അഡയിൽ ഒരു പുതിയ അഡാ അല്ലെങ്കിൽ ചെക്ക്ഇൻ ചേർത്ത് എംപോയിന്റുകൾ നേടുക",
        Peoplehaveliked: "ആളുകൾ ഇഷ്‌ടപ്പെട്ടു",
        whichplaceyoustand: "നിങ്ങൾ ഇപ്പോൾ ഏത് അഡയിലാണ്? വന്നുചേരുകയും പേര്രജിസ്റ്റര് ചെയ്യുകയും ചെയ്യുക!",
        Atwhichplace: "നിങ്ങൾ ഇപ്പോൾ ഏത് അഡയിലാണ്? വന്നുചേരുകയും പേര്രജിസ്റ്റര് ചെയ്യുകയും ചെയ്യുക!",
        likes: "ഇഷ്‌ടങ്ങൾ",
        share: "പങ്കിടുക",
        like: "ലൈക്ക്",
        comments: "അഭിപ്രായങ്ങൾ",
        isAt: "ആണ്",
        FullAddress: "മുഴുവൻ വിലാസം",
        housenumber: "വീട്ടു നമ്പർ, തെരുവ് അല്ലെങ്കിൽ ഗ്രാമം",
        BusinessName: "ബിസിനസ്സ് പേര്",
        Suchas: "അഗർവാൾ മിഠായി",
        AddNewCategory: "പുതിയ വിഭാഗം ചേർക്കുക",
        CREATE: "സൃഷ്ടിക്കാൻ",
        CANCEL: "റദ്ദാക്കുക",
        city: "നഗരം",
        addCity: "നഗരം ചേർക്കുക",
        Mobile: "ബന്ധപ്പെടേണ്ട നമ്പർ",
        enterMobileNumber: "മൊബൈൽ നമ്പർ നൽകുക",
        pincode: "പിൻ",
        enterpincode: "പിൻ",
        state: "സംസ്ഥാനം",
        AddState: "സംസ്ഥാനം ചേർക്കുക",
        wentWrong: "എന്തോ തെറ്റായി സംഭവിച്ചു !! ദയവായി വീണ്ടും ശ്രമിക്കുക",
        category: "വിഭാഗം",
        Createcategory: "വിഭാഗം സൃഷ്ടിക്കുക",
        UploadingImage: "ഫോട്ടോ അപ്‌ലോഡുചെയ്യുന്നു",
        AddAdda: "അഡാ ചേർക്കുക",
        nofeed: "വാർത്ത ഇല്ല",
        PleaseEnterdetails: "വിശദാംശങ്ങൾ നൽകുക",
        Pleaseentercomment: "അഭിപ്രായം നൽകുക",

    },
    mr: {
        AddonAdda: "एक जोडा जोडा",
        notFindAdda: "आपला अडा शोधू शकलो नाही? कृपया तुमचा अड्डा जोडा",
        AddPhoto: "फोटो जोडा",
        earnMpoints: "एमपी पॉइंट्स मिळविण्यासाठी अ‍ॅडमध्ये एक अ‍ॅड किंवा चेकइन जोडा",
        postOffice: "पोस्ट ऑफिस",
        meter: "मीटर",
        VerifiedbyMall91: "मॉल 91 द्वारे सत्यापित",
        Suggestandedit: "संपादन सुचवा",
        GiveRating: "रेटिंग द्या",
        Details: "तपशील",
        MondaytoSaturday: "सोमवार ते शनिवार",
        checkIn: "चेकइन",
        CheckInAtAdda: "अडावर चेक इन करा",
        ShareExperience: "आपला अनुभव अडाबरोबर सामायिक करा आणि एमपीइंट्स मिळवा",
        AddaName: "अडाचे नाव",
        AddAddanotfound: "अड्डा सापडला नाही",
        Iamhere: "मी येथे आहे",
        Writesomethinghere: "कृपया काही शब्द लिहा ..",
        plzCheckin: "चेकइन",
        PickyourCurrentLocation: "आपले वर्तमान स्थान निवडा",
        TurnonLocation: "स्थान सेवा चालू करा",
        NoRecordsavailable: "रेकॉर्ड उपलब्ध नाहीत",
        YoursPosts: "आपले पोस्ट्स",
        Makeasuggestion: "एक सल्ला द्या",
        Helpwithyoursuggestion: "आपल्या मौल्यवान सूचनांसह आम्हाला मदत करा",
        Addnewphoto: "नवीन फोटो जोडा",
        warning: "संबंधित चित्रे आणि अचूक माहितीसह आपल्या सूचनांचे समर्थन करा.",
        submit: "प्रस्तुत करणे",
        AllcheckIns: "सर्व चेकइन",
        Nearbycheckins: "जवळील चेकिन",
        Home: "मुख्यपृष्ठ",
        AllAddas: "सर्व अडास",
        Notification: "सूचना",
        Profile: "प्रोफाइल",
        TotalPost: "एकूण पोस्ट",
        TotalLikes: "एकूण आवडी",
        TotalComments: "एकूण टिप्पण्या",
        Peoplehavecommented: "लोकांनी प्रतिक्रिया दिल्या आहेत",
        TypeAcomment: "आपली सामग्री येथे टाइप करा ..",
        GototheAdda: "अडावर जा",
        intro: "एका अडावर एक नवीन अ‍ॅडा किंवा चेकइन जोडा आणि एमपी पॉईंट मिळवा",
        Peoplehaveliked: "लोकांना आवडले आहे",
        whichplaceyoustand: "आपण आता कोणत्या अडावर आहात? चेकइन!",
        Atwhichplace: "आपण आता कोणत्या अडावर आहात? चेकइन!",
        likes: "आवडी",
        share: "सामायिक करा",
        like: "आवडले",
        comments: "टिप्पण्या",
        isAt: "येथे आहे",
        FullAddress: "संपूर्ण पत्ता",
        housenumber: "घर क्रमांक, रस्ता किंवा गाव",
        BusinessName: "व्यवसायाचे नाव",
        Suchas: "अग्रवाल मिठाई",
        AddNewCategory: "नवीन श्रेणी जोडा",
        CREATE: "तयार करा",
        CANCEL: "रद्द करा",
        city: "शहर",
        addCity: "शहर जोडा",
        Mobile: "संपर्क क्रमांक",
        enterMobileNumber: "मोबाइल नंबर प्रविष्ट करा",
        pincode: "पिन",
        enterpincode: "पिन",
        state: "राज्य",
        AddState: "राज्य जोडा",
        wentWrong: "काहीतरी चूक झाली!! कृपया पुन्हा प्रयत्न करा",
        category: "वर्ग",
        Createcategory: "श्रेणी तयार करा",
        UploadingImage: "फोटो अपलोड करत आहे",
        AddAdda: "जोडा जोडा",
        nofeed: "काहीच बातमी नाही",
        PleaseEnterdetails: "कृपया तपशील प्रविष्ट करा",
        Pleaseentercomment: "कृपया टिप्पणी प्रविष्ट करा",
    },

    pa: {
        AddonAdda: "ਅੱਡਾ ਸ਼ਾਮਲ ਕਰੋ",
        notFindAdda: "ਕੀ ਤੁਹਾਨੂੰ ਆਪਣਾ ਅੱਡਾ ਨਹੀਂ ਮਿਲਿਆ? ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਅੱਡਾ ਸ਼ਾਮਲ ਕਰੋ",
        AddPhoto: "ਫੋਟੋ ਸ਼ਾਮਲ ਕਰੋ",
        earnMpoints: "ਆਪਣਾ ਅੱਡਾ ਸ਼ਾਮਲ ਕਰੋ ਜਾਂ ਕਿਸੇ ਵੀ ਅੱਡਾ ਤੇ ਚੈੱਕਇਨ ਕਰੋ ਅਤੇ MPoints ਕਮਾਓ",
        postOffice: "ਡਾਕਘਰ",
        meter: "ਮੀਟਰ",
        VerifiedbyMall91: "Mall91 ਦੁਆਰਾ ਪ੍ਰਮਾਣਿਤ",
        Suggestandedit: "ਸੰਪਾਦਨ ਦਾ ਸੁਝਾਅ ਦਿਓ",
        GiveRating: "ਰੇਟਿੰਗ ਦਿਓ",
        Details: "ਵੇਰਵਾ",
        MondaytoSaturday: "ਸੋਮਵਾਰ ਤੋਂ ਸ਼ਨੀਵਾਰ",
        checkIn: "ਚੈੱਕਇਨ",
        CheckInAtAdda: "ਅੱਡੇ'ਤੇ ਚੈੱਕ ਇਨ ਕਰੋ",
        ShareExperience: "ਅੱਡੇ ਤੇ ਅਪਨਾ ਤਜੁਰਬਾ ਸਾਂਝਾ ਕਰੋ ਅਤੇ ਕਮਾਓ MPoints",
        AddaName: "ਅੱਡੇ ਦਾ ਨਾਮ",
        AddAddanotfound: "ਅੱਡਾ ਨਹੀਂ ਮਿਲਿਆ",
        Iamhere: "ਮੈਂ ਇਥੇ ਹਾਂ",
        Writesomethinghere: "ਇਥੇ ਕੁਝ ਲਿਖੋ….",
        plzCheckin: "ਚੈੱਕਇਨ",
        PickyourCurrentLocation: "ਆਪਣਾ ਮੌਜੂਦਾ ਸਥਾਨ ਚੁਣੋ",
        TurnonLocation: "ਲੋਕੇਸ਼ਨ ਸਰਵਿਸਜ਼ ਚਾਲੂ ਕਰੋ",
        NoRecordsavailable: "ਕੋਈ ਰਿਕਾਰਡ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
        YoursPosts: "ਤੁਹਾਡੀ ਪੋਸਟ",
        Makeasuggestion: "ਸੁਝਾਅ ਦਿਓ",
        Helpwithyoursuggestion: "ਆਪਣੇ ਕੀਮਤੀ ਸੁਝਾਅ ਸਾਂਝੇ ਕਰੋ",
        Addnewphoto: "ਨਵੀਂ ਫੋਟੋ ਸ਼ਾਮਲ ਕਰੋ",
        warning: "ਆਪਂਣੇ ਸੁਝਾਵ ਤੇ ਨਾਲ ਸੰਬੰਧਿਤ ਤਸਵੀਰਾਂ ਅਤੇ ਸਹੀ ਜਾਣਕਾਰੀ ਜੋੜੋ",
        submit: "ਜਮ੍ਹਾ ਕਰੋ",
        AllcheckIns: "ਸਾਰੇ ਚੈਂਕਿੰਸ",
        Nearbycheckins: "ਨੇੜਲੇ ਚੈਂਕਿੰਸ",
        Home: "ਹੋਮ",
        AllAddas: "ਸਾਰੇ ਅੱਡੇ",
        Notification: "ਸੂਚਨਾ",
        Profile: "ਪ੍ਰੋਫਾਈਲ",
        TotalPost: "ਸਾਰੇ ਪੋਸਟਸ",
        TotalLikes: "ਸਾਰੇ ਲੀਕੇਜ਼",
        TotalComments: "ਸਾਰੇ ਕਮੇੰਟ੍ਸ",
        Peoplehavecommented: "ਲੋਕਾਂ ਨੇ ਕਮੇੰਟ੍ਸ ਕੀਤੇ ਨੇ",
        TypeAcomment: "ਕੰਮੈਂਟ ਟਾਈਪ ਕਰੋ..",
        GototheAdda: "ਅੱਡੇ ਤੇ ਜਾਓ",
        intro: "ਅੱਡਾ ਜੋੜੋਂ ਆਂ ਕਿਸੇ ਅੱਡੇ ਤੇ ਚੇਕੀਨ ਕਰੋ ਤੇ ਜਿੱਤੋ MPoints",
        Peoplehaveliked: "ਲੋਕਾਂ ਨੇ ਲਾਇਕ ਕੀਤਾ ਹੈ",
        whichplaceyoustand: "ਹੁਣ ਤੁਸੀ ਕਿਸ ਅੱਡੇ ਤੇ ਹੋ ? ਚੇਕੀਨ ਕਰੋ !",
        Atwhichplace: "ਹੁਣ ਤੁਸੀ ਕਿਸ ਅੱਡੇ ਤੇ ਹੋ ? ਚੇਕੀਨ ਕਰੋ!",
        likes: "ਲਾਇਕਸ",
        share: "ਸ਼ੇਰ",
        like: "ਲਾਇਕ",
        comments: "ਕਮੇੰਟ੍ਸ",
        isAt: "",
        FullAddress: "ਪੂਰਾ ਪਤਾ",
        housenumber: "ਮਕਾਨ ਨੰਬਰ, ਗਲੀ ਯਾਂ ਪੇੰਡ ਜੋੜੋ",
        BusinessName: "ਅੱਡੇ ਦਾ ਨਾਮ	",
        Suchas: "ਜਿਵੇਂ: ਅਗਰਵਾਲ ਹਲਵਾਈ",
        AddNewCategory: "ਨਵੇਂ ਕੈਟਾਗਰੀ ਜੋੜੇਂ",
        CREATE: "ਬਣਾਓ",
        CANCEL: "ਕੈਂਸਲ ਕਰੋ",
        city: "ਸ਼ਹਿਰ",
        addCity: "ਸ਼ਹਿਰ ਜੋੜੇਂ",
        enterMobileNumber: "ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
        Mobile: "ਮੋਬਾਈਲ",
        pincode: "ਪਿੰਨ ਕੋਡ",
        enterpincode: "ਪਿੰਨ ਕੋਡ ਜੋੜੇਂ",
        state: "ਰਾਜ੍ਯ",
        AddState: "ਰਾਜ੍ਯ ਜੋੜੇਂ",
        wentWrong: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ!! ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ",
        category: "ਸ਼੍ਰੇਣੀ",
        Createcategory: "ਸ਼੍ਰੇਣੀ ਬਣਾਓ",
        UploadingImage: "ਫੋਟੋ ਅਪਲੋਡਿੰਗ",
        AddAdda: "ਐਡਾ ਸ਼ਾਮਲ ਕਰੋ",
        nofeed: "ਹਜੇ  ਅੱਡੇ ਖਾਲੀ ਹਨ",
        PleaseEnterdetails: "ਕਿਰਪਾ ਕਰਕੇ ਵੇਰਵਾ ਦਰਜ ਕਰੋ",
        Pleaseentercomment: "ਟਿੱਪਣੀ ਦਰਜ ਕਰੋ ਜੀ",

    },
    ta: {
        AddonAdda: "ஒரு அடா",
        notFindAdda: "உங்கள் అడ్డా ஐ கண்டுபிடிக்க முடியவில்லை? உங்கள் Adda ஐச் சேர்க்கவும்",
        AddPhoto: "புகைப்படம் சேர்க்க",
        earnMpoints: "MPoints சம்பாதிக்க ஒரு Adda இல் ஒரு Adda அல்லது Checkin ஐச் சேர்க்கவும்",
        postOffice: "தபால் அலுவலகம்",
        meter: "மீட்டர்",
        VerifiedbyMall91: "Mall91 ஆல் சரிபார்க்கப்பட்டது",
        Suggestandedit: "திருத்தத்தை பரிந்துரைக்கவும்",
        GiveRating: "மதிப்பீடு கொடுங்கள்",
        Details: "விவரங்கள்",
        MondaytoSaturday: "திங்கள் முதல் சனி வரை",
        checkIn: "புதுப்பிப்பது",
        CheckInAtAdda: "ஒரு அடாவில் சரிபார்க்கவும்",
        ShareExperience: "உங்கள் அனுபவத்தை அடிடாவுடன் பகிர்ந்து கொள்ளுங்கள் மற்றும் எம்.பி.",
        AddaName: "அடாவின் பெயர்",
        AddAddanotfound: "அடிடா கிடைக்கவில்லை",
        Iamhere: "நான் இங்கு இருக்கிறேன்",
        Writesomethinghere: "சில சொற்களை எழுதுங்கள் ..",
        plzCheckin: "புதுப்பிப்பது",
        PickyourCurrentLocation: "உங்கள் தற்போதைய இருப்பிடத்தைத் தேர்வுசெய்க",
        TurnonLocation: "இருப்பிட சேவைகளை இயக்கவும்",
        NoRecordsavailable: "பதிவுகள் எதுவும் கிடைக்கவில்லை",
        YoursPosts: "உங்கள் இடுகைகள்",
        Makeasuggestion: "ஒரு பரிந்துரை செய்யுங்கள்",
        Helpwithyoursuggestion: "உங்கள் மதிப்புமிக்க பரிந்துரைகளுக்கு எங்களுக்கு உதவுங்கள்",
        Addnewphoto: "புதிய புகைப்படத்தைச் சேர்க்கவும்",
        warning: "தொடர்புடைய படங்கள் மற்றும் துல்லியமான தகவல்களுடன் உங்கள் பரிந்துரைகளை ஆதரிக்கவும்.",
        submit: "சமர்ப்பி",
        AllcheckIns: "அனைத்து செக்கின்களும்",
        Nearbycheckins: "அருகிலுள்ள செக்கின்ஸ்",
        Home: "வீடு",
        AllAddas: "அனைத்து Addas",
        Notification: "அறிவித்தல்",
        Profile: "பதிவு செய்தது",
        TotalPost: "மொத்த இடுகைகள்",
        TotalLikes: "மொத்த விருப்பங்கள்",
        TotalComments: "மொத்த கருத்துகள்",
        Peoplehavecommented: "மக்கள் கருத்து தெரிவித்துள்ளனர்",
        TypeAcomment: "உங்கள் உள்ளடக்கத்தை இங்கே தட்டச்சு செய்க ..",
        GototheAdda: "ஒரு அடிடாவுக்குச் செல்லுங்கள்",
        intro: "ஒரு అడ్డా இல் புதிய అడ్డా அல்லது చెకిన్ ஐச் சேர்த்து MPoints ஐப் பெறுங்கள்",
        Peoplehaveliked: "மக்கள் விரும்பினர்",
        whichplaceyoustand: "நீங்கள் இப்போது எந்த அடாவில் இருக்கிறீர்கள்? புதுப்பிப்பது!",
        Atwhichplace: "நீங்கள் இப்போது எந்த அடாவில் இருக்கிறீர்கள்? புதுப்பிப்பது!",
        likes: "தோட்",
        share: "பகிர்",
        like: "போல்",
        comments: "கருத்துக்கள்",
        isAt: "இல் உள்ளது",
        FullAddress: "முழு முகவரி",
        housenumber: "வீட்டு எண், தெரு அல்லது கிராமம்",
        BusinessName: "வணிகத்தின் பெயர்",
        Suchas: "அகர்வால் மிட்டாய்",
        AddNewCategory: "புதிய வகையைச் சேர்க்கவும்",
        CREATE: "உருவாக்க",
        CANCEL: "இரத்து",
        city: "நகரம்",
        addCity: "நகரத்தைச் சேர்",
        Mobile: "தொடர்பு எண்",
        enterMobileNumber: "மொபைல் எண்ணை உள்ளிடவும்",
        pincode: "பின்னை",
        enterpincode: "பின்னை",
        state: "நிலை",
        AddState: "மாநிலத்தைச் சேர்",
        wentWrong: "ஏதோ தவறு ஏற்பட்டது !! மீண்டும் முயற்சிக்கவும்",
        category: "வகை",
        Createcategory: "வகை உருவாக்கவும்",
        UploadingImage: "புகைப்பட பதிவேற்றம்",
        AddAdda: "அடிடாவைச் சேர்க்கவும்",
        nofeed: "செய்தி இல்லை",
        PleaseEnterdetails: "விவரங்களை உள்ளிடவும்",
        Pleaseentercomment: "கருத்தை உள்ளிடவும்",
    },
    te: {
        AddonAdda: "ఒక అడ్డాను జోడించండి",
        notFindAdda: "మీ అడ్డాను గుర్తించలేదా? దయచేసి మీ అడ్డాను జోడించండి",
        AddPhoto: "ఫోటోను జోడించండి",
        earnMpoints: "MPoints సంపాదించడానికి Adda లో Adda లేదా Checkin ని జోడించండి",
        postOffice: "తపాలా కార్యాలయము",
        meter: "మీటర్",
        VerifiedbyMall91: "మాల్ 91 చే ధృవీకరించబడింది",
        Suggestandedit: "సవరణను సూచించండి",
        GiveRating: "రేటింగ్ ఇవ్వండి",
        Details: "వివరాలు",
        MondaytoSaturday: "సోమవారం నుండి శనివారం వరకు",
        checkIn: "చెకిన్",
        CheckInAtAdda: "అడ్డా వద్ద తనిఖీ చేయండి",
        ShareExperience: "మీ అనుభవాన్ని అడ్డాతో పంచుకోండి మరియు ఎంపాయింట్‌లను సంపాదించండి",
        AddaName: "అడ్డా పేరు",
        AddAddanotfound: "అడ్డా కనుగొనబడలేదు",
        Iamhere: "నేను ఇక్కడ ఉన్నాను",
        Writesomethinghere: "దయచేసి కొన్ని పదాలు రాయండి ..",
        plzCheckin: "చెకిన్",
        PickyourCurrentLocation: "మీ ప్రస్తుత స్థానాన్ని ఎంచుకోండి",
        TurnonLocation: "స్థాన సేవలను ప్రారంభించండి",
        NoRecordsavailable: "రికార్డులు అందుబాటులో లేవు",
        YoursPosts: "మీ పోస్ట్లు",
        Makeasuggestion: "ఒక సూచన చేయండి",
        Helpwithyoursuggestion: "మీ విలువైన సూచనలతో మాకు సహాయం చేయండి",
        Addnewphoto: "క్రొత్త ఫోటోను జోడించండి",
        warning: "సంబంధిత చిత్రాలు మరియు ఖచ్చితమైన సమాచారంతో మీ సలహాలకు మద్దతు ఇవ్వండి.",
        submit: "సమర్పించండి",
        AllcheckIns: "అన్ని చెకిన్లు",
        Nearbycheckins: "సమీపంలోని చెకిన్లు",
        Home: "హోమ్",
        AllAddas: "అన్ని అడ్డాలు",
        Notification: "నోటిఫికేషన్",
        Profile: "ప్రొఫైల్",
        TotalPost: "మొత్తం పోస్ట్లు",
        TotalLikes: "మొత్తం ఇష్టాలు",
        TotalComments: "మొత్తం వ్యాఖ్యలు",
        Peoplehavecommented: "ప్రజలు వ్యాఖ్యలు చేశారు",
        TypeAcomment: "మీ కంటెంట్‌ను ఇక్కడ టైప్ చేయండి ..",
        GototheAdda: "ఒక అడ్డాకు వెళ్ళండి",
        intro: "ఒక Adda లో క్రొత్త Adda లేదా checkin ని జోడించి MPoints సంపాదించండి",
        Peoplehaveliked: "ప్రజలు ఇష్టపడ్డారు",
        whichplaceyoustand: "మీరు ఇప్పుడు ఏ అడ్డా వద్ద ఉన్నారు? చెకిన్!",
        Atwhichplace: "మీరు ఇప్పుడు ఏ అడ్డా వద్ద ఉన్నారు? చెకిన్!",
        likes: "ఇష్టాలు",
        share: "వాటా",
        like: "ఇలా",
        comments: "వ్యాఖ్యలు",
        isAt: "వద్ద ఉంది",
        FullAddress: "పూర్తి చిరునామా",
        housenumber: "ఇంటి సంఖ్య, వీధి లేదా గ్రామం",
        BusinessName: "వ్యాపారం పేరు",
        Suchas: "అగర్వాల్ మిఠాయి",
        AddNewCategory: "క్రొత్త వర్గాన్ని జోడించండి",
        CREATE: "సృష్టించదు",
        CANCEL: "రద్దు చేయండి",
        city: "నగరం",
        addCity: "నగరాన్ని జోడించండి",
        Mobile: "సంప్రదింపు సంఖ్య",
        enterMobileNumber: "మొబైల్ నంబర్‌ను నమోదు చేయండి",
        pincode: "పిన్",
        enterpincode: "పిన్",
        state: "రాష్ట్రం",
        AddState: "రాష్ట్రాన్ని జోడించండి",
        wentWrong: "ఎక్కడో తేడ జరిగింది!! దయచేసి మళ్ళీ ప్రయత్నించండి",
        category: "వర్గం",
        Createcategory: "వర్గాన్ని సృష్టించండి",
        UploadingImage: "ఫోటో అప్‌లోడ్",
        AddAdda: "అడ్డా జోడించండి",
        nofeed: "సమాచారం లేదు",
        PleaseEnterdetails: "దయచేసి వివరాలను నమోదు చేయండి",
        Pleaseentercomment: "దయచేసి వ్యాఖ్యను నమోదు చేయండి",

    },

}

const i18n = new VueI18n({
    locale: 'hi', // set locale
    fallbackLocale: 'hi', // set fallback locale
    messages // set locale messages
})

export default i18n